import { useState } from 'react'

const DEFAULT_CONFIG = {
  title: '转盘小工具',
  subtitle: '请自由设置副标题',
  items: [
    { id: 1, text: '选项1', color: '#ef4444', weight: 1 },
    { id: 2, text: '选项2', color: '#f97316', weight: 1 },
    { id: 3, text: '选项3', color: '#eab308', weight: 1 },
    { id: 4, text: '选项4', color: '#22c55e', weight: 1 },
    { id: 5, text: '选项5', color: '#3b82f6', weight: 1 },
    { id: 6, text: '选项6', color: '#8b5cf6', weight: 1 }
  ]
}

export const useWheelConfig = () => {
  // 从localStorage加载配置
  const loadConfig = () => {
    try {
      const savedConfig = localStorage.getItem('wheelConfig')
      return savedConfig ? JSON.parse(savedConfig) : DEFAULT_CONFIG
    } catch (error) {
      console.error('加载配置失败:', error)
      return DEFAULT_CONFIG
    }
  }

  const [config, setConfig] = useState(loadConfig)
  
  // 派生状态，方便外部直接使用
  const wheelItems = config.items
  const title = config.title
  const subtitle = config.subtitle

  // 保存配置到localStorage
  const saveConfig = (newConfig) => {
    try {
      localStorage.setItem('wheelConfig', JSON.stringify(newConfig))
    } catch (error) {
      console.error('保存配置失败:', error)
    }
  }

  // 更新整个配置
  const updateConfig = (newConfig) => {
    setConfig(newConfig)
    saveConfig(newConfig)
  }

  // 处理配置变更（仅items）
  const handleItemsChange = (newItems) => {
    const newConfig = { ...config, items: newItems }
    updateConfig(newConfig)
  }

  // 更新标题
  const updateTitle = (newTitle) => {
    const newConfig = { ...config, title: newTitle }
    updateConfig(newConfig)
  }

  // 更新副标题
  const updateSubtitle = (newSubtitle) => {
    const newConfig = { ...config, subtitle: newSubtitle }
    updateConfig(newConfig)
  }

  // 加载示例
  const loadExample = (example) => {
    const newItems = example.items.map((item, index) => ({
      ...item,
      id: Date.now() + index // 生成新的ID避免冲突
    }))
    
    const newConfig = { 
      ...config, 
      items: newItems,
      title: example.title,
      subtitle: example.subtitle
    }
    updateConfig(newConfig)
  }

  // 重置/清空
  const resetConfig = () => {
    const defaultItems = [
      { id: 1, text: '选项1', color: '#ef4444', weight: 1 },
      { id: 2, text: '选项2', color: '#3b82f6', weight: 1 }
    ]
    const newConfig = {
      title: '转盘小工具',
      subtitle: '请自由设置副标题',
      items: defaultItems
    }
    updateConfig(newConfig)
  }

  return {
    config,
    wheelItems,
    title,
    subtitle,
    handleItemsChange,
    updateTitle,
    updateSubtitle,
    loadExample,
    resetConfig
  }
}



